import { create } from 'zustand';

import { ApiRegion } from '@/config';

import { RegionalApiError } from './regionalApi';

type RegionalAuthErrorState = {
  errors: Partial<Record<ApiRegion, RegionalApiError>>;
};

/** Latest US auth failure per region. Canada is never recorded: Canada keeps its own 401 handling. */
export const useRegionalAuthErrorStore = create<RegionalAuthErrorState>(() => ({ errors: {} }));

export const isRegionalAuthError = (error: unknown): error is RegionalApiError =>
  error instanceof RegionalApiError && (error.kind === 'unauthorized' || error.kind === 'forbidden');

export const reportRegionalAuthError = (region: ApiRegion, error: unknown) => {
  if (region === ApiRegion.CA || !isRegionalAuthError(error)) {
    return;
  }
  useRegionalAuthErrorStore.setState(state => ({ errors: { ...state.errors, [region]: error } }));
};

export const clearRegionalAuthError = (region: ApiRegion) => {
  if (!useRegionalAuthErrorStore.getState().errors[region]) {
    return;
  }
  useRegionalAuthErrorStore.setState(state => {
    const errors = { ...state.errors };
    delete errors[region];
    return { errors };
  });
};

export const clearAllRegionalAuthErrors = () => {
  useRegionalAuthErrorStore.setState({ errors: {} });
};
